"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecordRequest = void 0;
var RecordRequest = /** @class */ (function () {
    function RecordRequest() {
    }
    return RecordRequest;
}());
exports.RecordRequest = RecordRequest;
;
//# sourceMappingURL=record.request.js.map